import React, { useEffect, useRef, useState } from 'react';
import { getCurrentReader } from '../../auth/getCurrentReader';
import { followAuthor, unfollowAuthor, getReaderFollowGraph } from '../../services/followService';

export default function AuthorCircleButton({ author }) {
  const membershipDialog = useRef(null);
  const [joined, setJoined] = useState(false);
  const [busy, setBusy] = useState(true);
  const [self, setSelf] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let canceled = false;
    setBusy(true);
    setJoined(false);
    setError('');
    setSelf(false);
    (async () => {
      try {
        const reader = await getCurrentReader();
        const graph = reader ? await getReaderFollowGraph() : null;
        if (!canceled) {
          setSelf(reader?.readerSub === author.id);
          setJoined(!!graph?.authors?.some(item => item.id === author.id));
        }
      } catch { if (!canceled) setError(''); }
      finally { if (!canceled) setBusy(false); }
    })();
    return () => { canceled = true; };
  }, [author.id]);
  async function toggle() {
    setBusy(true); setError('');
    try {
      const reader = await getCurrentReader();
      if (!reader?.readerSub) { membershipDialog.current.showModal(); return; }
      if (reader.readerSub === author.id) return;
      const graph = await getReaderFollowGraph();
      const following = graph.authors.some(item => item.id === author.id);
      await (following ? unfollowAuthor : followAuthor)({ id: author.id, name: author.name });
      setJoined(!following);
    } catch { setError('Could not update Circle membership. Please try again.'); }
    finally { setBusy(false); }
  }
  if (self) return null;
  return <div><button type="button" disabled={busy} onClick={toggle} className="w-full inline-flex items-center justify-center rounded-full border border-bookish-purple/20 bg-white px-5 py-3 text-sm font-semibold text-bookish-purple hover:bg-bookish-purple/5 disabled:opacity-60">{busy ? 'Updating…' : joined ? 'Joined ✓ / Leave Circle' : `Join ${author.name}'s Circle`}</button>{error && <p role="alert" className="mt-2 text-sm text-red-700">{error}</p>}
    <dialog ref={membershipDialog} aria-labelledby="reader-membership-title" aria-describedby="reader-membership-message" className="w-full max-w-md rounded-3xl border border-bookish-purple/20 bg-white p-6 text-bookish-purple shadow-xl backdrop:bg-black/40">
      <h2 id="reader-membership-title" className="font-serif text-2xl">Become a Reader Member</h2>
      <p id="reader-membership-message" className="mt-3">You can only follow authors by becoming a reader member and signing in.</p>
      <div className="mt-6 flex gap-3">
        <a href="https://bookishcircle.com/signupreader" className="rounded-full bg-bookish-purple px-5 py-3 font-semibold text-white">Sign Up</a>
        <button type="button" onClick={() => membershipDialog.current.close()} className="rounded-full border border-bookish-purple/20 px-5 py-3 font-semibold">Cancel</button>
      </div>
    </dialog>
  </div>;
}
